module.exports = __webpack_public_path__ + "static/media/2-0.e042d647.m4a";